const actions = {
  modals: {
    setOpenPurchaseExtraSuggestedTruckers: 'set_open_purchase_extra_suggested_truckers',
    setClosePurchaseExtraSuggestedTruckers: 'set_close_purchase_extra_suggested_truckers',
  },
  checkoutDrawer: {
    set: 'checkout_drawer_view',
    close: 'close_checkout_drawer',
  },
};

export default actions;
